import React from 'react';
import PropTypes from 'prop-types';

import { getFormattedDateTime } from '../../../../helpers/DateTime';

const CollectedDetailsListItem = ({ element }) => (
  <tr>
    <td>
      {element.name ? element.name : '-'}
    </td>
    <td>
      {element.email ? element.email : '-'}
    </td>
    <td>
      {element.type ? element.type : '-'}
    </td>
    <td colSpan="2">
      {element.created_at ? getFormattedDateTime(element.created_at) : '-'}
    </td>
  </tr>
);

CollectedDetailsListItem.propTypes = {
  element: PropTypes.object.isRequired,
};

export default CollectedDetailsListItem;
